export default class SpinnerController {
  public needToShow = false;
  public svgSize = 40;
}



// WEBPACK FOOTER //
// src/app/components/spinner/spinner.controller.ts